module.exports = __webpack_public_path__ + "img/check-gray.338be72a.svg";